<template lang="">
  <div class="mains">
    <div class="container">
      <div class="header_title">企业信息管理</div>
      <div class="top">
        <Button class="newBotton" @click="inAddVal()">
          <!-- <Icon type="ios-add" size="50px" /> -->
          <span class="newBottonText">新增</span>
        </Button>
        <div class="select">
          <Input v-model="selectVal" search placeholder="输入企业名称或代码" />
        </div>
      </div>
      <div class="main mains">
        <el-empty description="没有数据哦！" v-if="pageData.length==0"/>
        <Table border :columns="columns" :data="pageData" style="width: 100%" v-if="pageData.length!==0">
          <!-- <Table border :columns="columns" :data="datas" style="width:100%;"> -->
          <template #name="{ row }">
            <strong>{{ row.name }}</strong>
          </template>
          <template #action="{ row, index }">
            <Button style="margin-right: 5px" @click="show(index)">修改</Button>
            <Button type="error" @click="remove(index)">删除</Button>
          </template>
        </Table>
        <!-- 分页 -->
        <Page
          class="page"
          :modelValue="pages"
          :total="allPage"
          simple
          @on-change="page"
        />
      </div>

      <Drawer title="修改企业资料" :closable="false" v-model="value" width="600">
        <updataClient :datas="pageData[index]" @change="upClientClose"></updataClient>
      </Drawer>
      <Drawer
        title="添加企业资料"
        :closable="false"
        v-model="addVal"
        width="600"
      >
        <NewClient @change="addClientList"></NewClient>
      </Drawer>
    </div>
  </div>
</template>
<script>
import NewClient from "@/components/NewClient";
import updataClient from "@/views/CompanyInfromation/updataClient";
import { GetClients,DelClients } from "@/api/index";
export default {
  data() {
    return {
      selectVal: "",
      value: false,
      addVal: false,
      columns: [
        {
          title: "id",
          key: "id",
          width: 65,
          // fixed: 'left'
        },
        {
          title: "企业代码",
          key: "incode",
          width: 120,
          // fixed: 'left'
        },
        {
          title: "企业名称",
          key: "name",
          minWidth:250,
        },
        {
          title: "账号",
          key: "account",
          minWidth:100,
        },
        {
          title: "负责人",
          key: "incharge",
          minWidth:100,
        },
        {
          title: "联系电话",
          key: "phone",
          minWidth:150,
        },
        {
          title: "功能",
          key: "module",
          minWidth:250,
        },
        {
          title: "行业",
          key: "city",
          minWidth:250,
        },
        {
          title: "地址",
          key: "site",
          minWidth:300,
        },
        {
          title: "到期时间",
          key: "date",
          minWidth:200,
        },
        {
          title: " ",
          slot: "action",
          width: 170,
          align: "center",
          fixed: "right",
        },
      ],
      // 源数据
      datas: [],
      // 搜索后的数据
      inData: [],
      // 分页后的数据
      pageData: [],
      inDatas: {
        inCode: "",
        inName: "",
        inWrite: "",
        inDate: "",
      },
      pages: 1,
      allPage: 1,
      index:''
    };
  },
  components: {
    NewClient,
    updataClient,
  },
  beforeCreate() {},
  mounted() {
    // 获取企业资料
    GetClients({}).then((res) => {
      if (res.code == 402) {
        this.$Notice.error({ title: "没有权限！" });
      }
      // console.log(res);
      this.datas = res;
      // 初始列表过滤10
      // console.log(this.datas);

      this.pageData = res.filter((p, key) => {
        if (key < this.pages * 10 && key >= this.pages * 10 - 10) {
          return p;
        }
      });
      this.allPage = this.datas.length;
    });
  },
  updated() {},
  watch: {
    // 搜索过滤
    selectVal(newVal, oldVal) {
      var data = this.datas.filter((p) => {
        if (p.name.indexOf(newVal) !== -1) {
          return p;
        }
        if (p.incode.indexOf(newVal) !== -1) {
          return p;
        }
      });
      this.pages = 1;
      this.allPage = data.length;
      let arr = data.filter((p, key) => {
        if (key < this.pages * 10 && key >= this.pages * 10 - 10) {
          return p;
        }
      });
      this.pageData = arr;
    },
  },
  methods: {
    upClientClose(){
      this.value = false
    },
    inAddVal(index) {
      this.addVal = true;
    },
    show(index) {
      this.index = index
      this.value = true;
    },
    // 删除按钮
    remove(index) {
      const code = this.pageData[index].name;
      const id = this.pageData[index].id;
      this.$confirm("此操作将永久删除" + code+", 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 提交删除请求
          DelClients({
            id,
          }).then((res) => {
            if (res.code == 402) {
              this.$Notice.error({ title: "没有权限！" });
            }
            if (res == 1) {
              this.pageData.splice(index, 1);
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message({
                type: "error",
                message: "删除失败！",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 分页过滤
    page(i) {
      this.pages = i;
      var data = this.datas.filter((p) => {
        return p.name.indexOf(this.selectVal) !== -1;
      });
      // this.pages = 1
      let arr = data.filter((p, key) => {
        if (key < this.pages * 10 && key >= this.pages * 10 - 10) {
          return p;
        }
      });
      this.pageData = arr;
    },
    // 接收来自子组件的回值---添加信息
    async addClientList(value) {
      this.datas.push(value);
    },
  },
};
</script>
<style scoped >
.top {
  width: 100%;
  background: white;
  padding: 15px;
  display: flex;
  flex-direction: row;
}

.select {
  margin-left: 10px;
}

.main {
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.page {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
